import { makeAutoObservable } from 'mobx';
import { JwtAuthResult } from '@codefluegel/wowis-rest-typescript-client';
import persistStore from './PersistStore';

const emptyUserData: JwtAuthResult | undefined = undefined;

export default class AuthStore {
  userData: JwtAuthResult | undefined = emptyUserData;

  constructor(persistanceKey?: string) {
    makeAutoObservable(this, {}, { autoBind: true });
    if (persistanceKey) {
      persistStore(this, ['userData'], persistanceKey);
    }
  }

  setUserData(userData: JwtAuthResult): void {
    this.userData = userData;
  }

  get getUserData() {
    return this.userData;
  }

  removeUserData(): void {
    this.userData = emptyUserData;
  }
}
